import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { offers } from "../../types";

const offerInitialState: offers.OfferStateType = {
  CoupanData: {
    data: null,
    isLoading: false,
    errors: "",
  },
  CoupanDiscount: {
    data: null,
    isLoading: false,
    errors: "",
  },
};

export const offerSlice = createSlice({
  name: "offer",
  initialState: offerInitialState,
  reducers: {
    coupanListDetailsRequest: (
      state: offers.OfferStateType,
      action: PayloadAction<any>
    ) => {
      state.CoupanData.isLoading = true;
      state.CoupanData.errors = "";
    },
    coupanListDetailsSuccess: (
      state: offers.OfferStateType,
      action: PayloadAction<any>
    ) => {
      state.CoupanData.isLoading = false;
      state.CoupanData.data = action.payload?.data;
    },
    coupanListDetailsError: (
      state: offers.OfferStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.CoupanData.isLoading = false;
      state.CoupanData.errors = error;
    },
    resetcoupanListDetails: (state: offers.OfferStateType) => {
      state.CoupanData = {
        data: null,
        isLoading: false,
        errors: "",
      };
    },
    checkDiscountRequest: (
      state: offers.OfferStateType,
      action: PayloadAction<any>
    ) => {
      state.CoupanDiscount.isLoading = true;
      state.CoupanDiscount.errors = "";
    },
    checkDiscountSuccess: (
      state: offers.OfferStateType,
      action: PayloadAction<any>
    ) => {
      state.CoupanDiscount.isLoading = false;
      state.CoupanDiscount.data = action.payload?.data;
    },
    checkDiscountError: (
      state: offers.OfferStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.CoupanDiscount.isLoading = false;
      state.CoupanDiscount.errors = error;
    },
    resetCoupanDiscount: (state: offers.OfferStateType) => {
      state.CoupanDiscount = {
        data: null,
        isLoading: false,
        errors: "",
      };
    },
  },
});

export const {
  coupanListDetailsRequest,
  coupanListDetailsSuccess,
  coupanListDetailsError,
  resetcoupanListDetails,
  checkDiscountRequest,
  checkDiscountSuccess,
  checkDiscountError,
  resetCoupanDiscount,
} = offerSlice.actions;

export default offerSlice.reducer;
